import { Play } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "@/contexts/LanguageContext";

const VideoGallery = () => {
  const { t } = useLanguage();
  const [activeVideo, setActiveVideo] = useState<string | null>(null);

  const videos = [
    { src: "/videos/restaurant-2.mov", title: t('video.atmosphere') },
    { src: "/videos/restaurant-3.mov", title: t('video.dishes') },
    { src: "/videos/restaurant-4.mov", title: t('video.experience') },
  ];

  return (
    <section className="section-padding bg-gradient-to-b from-luxury-dark/50 via-luxury-dark/30 to-luxury-dark/50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <p className="text-gold text-lg font-medium tracking-wider uppercase mb-4 animate-text-glow">{t('video.title')}</p>
          <h2 className="heading-luxury text-foreground mb-6 text-gradient">
            {t('video.heading')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('video.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-8">
          {videos.map((video, index) => (
            <div key={index} className="flex flex-col">
              <div
                className="relative group overflow-hidden rounded-xl aspect-video cursor-pointer border border-gold/20 hover:border-gold/50 transition-all duration-500"
                onClick={() => setActiveVideo(video.src)}
              >
                {/* Video thumbnail */}
                <video
                  className="w-full h-full object-cover"
                  muted
                  loop
                  playsInline
                  preload="auto"
                >
                  <source src={video.src} type="video/quicktime" />
                  <source src={video.src} type="video/mp4" />
                </video>
                
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-black/10 group-hover:from-black/50 group-hover:via-black/20 group-hover:to-transparent transition-all duration-500" />

                {/* Play button - centered */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
                  <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold text-background shadow-gold ring-4 ring-gold/20 group-hover:ring-gold/40 transform group-hover:scale-110 transition-all duration-500">
                    <Play className="w-10 h-10 ml-1" />
                  </div>
                </div>
              </div>

              {/* Title below video */}
              <h3 className="text-center mt-3 text-lg font-serif font-semibold text-foreground">
                {video.title}
              </h3>
            </div>
          ))}
        </div>

        {/* Video Modal */}
        {activeVideo && (
          <div
            className="fixed inset-0 z-50 bg-background/95 flex items-center justify-center p-4 animate-fade-in"
            onClick={() => setActiveVideo(null)}
          >
            <div className="relative max-w-6xl w-full aspect-video">
              <video
                className="w-full h-full object-contain rounded-xl border border-gold/30"
                autoPlay
                controls
                playsInline
              >
                <source src={activeVideo} type="video/quicktime" />
                <source src={activeVideo} type="video/mp4" />
              </video>
              <button
                aria-label="Stäng video"
                className="absolute top-4 right-4 w-12 h-12 rounded-full bg-gold text-background hover:bg-gold-light transition-colors flex items-center justify-center"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveVideo(null);
                }}
              >
                ✕
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default VideoGallery;